<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a file picker
    *
    * @since 20200604
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <input type="hidden" :name="name" :value="uploadedDocuments">
        <flash-message ref="flashmessage" type='success' name='filepicker'></flash-message>
        <div v-if="readOnly && documentList.length == 0"></div>
        <div v-else-if="multi" class="row">           
            <div class="col-md-7">
                 <div class="card h-100">
                    <div class="card-block"> 
                        <div class="card-header pb-0">
                            <div class="row justify-content-between">
                                <label class="text-20 text-info">
                                    Documents<span class="badge badge-pill badge-info ml-2">{{documentList.length}}</span>
                                </label>
                             
                                <div class="text-right" v-if="documentList.length >3">
                                    <button type="button" class="btn btn-outline-info btn-sm" @click="show_all_docs">Show All</button>                                   
                                </div>                               
                            </div>
                        </div>                       
                        <div v-for="doc in docsHead" :key="doc.index" class="row d-flex pl-4 pt-2 pr-4 pb-2">                           
                            <div class="pl-2">
                                {{doc.document.orig_name}}
                            </div>
                            <div v-if="doc.waiting" class="pl-2">
                                Waiting for Upload
                            </div>
                            <div v-else-if="doc.uploading" class="pl-2">
                                <i class="fas fa-sync fa-spin"></i> Uploading
                            </div>
                            <div v-else-if="doc.error" class="pl-2 text-danger">
                                The upload failed
                            </div>
                            <div v-else class="pl-2 text-success">
                                Uploaded
                            </div>
                            <div class="pl-2 ml-auto">
                                <button v-if="allowCopy && doc.cdnLink !== null && !doc.waiting && !doc.uploading && !doc.error && !doc.deleting && (getExtension(doc.document.orig_name) == '.png' || getExtension(doc.document.orig_name) == '.gif' || getExtension(doc.document.orig_name) == '.jpg' || getExtension(doc.document.orig_name) == '.jpeg')" type="button" class="btn btn-primary btn-sm" @click="copyPublic(doc)">
                                    <i class="fa fa-copy" aria-hidden="true"></i></button> 
                                <a v-if="!doc.waiting && !doc.uploading && !doc.error && !doc.deleting" type="button" class="btn btn-primary btn-sm" :href="doc.route" target="_blank">
                                    <i class="fa fa-download" aria-hidden="true"></i></a> 
                                <a v-else type="button" class="btn btn-primary btn-sm" disabled target="_blank">
                                    <i class="fa fa-download" aria-hidden="true"></i></a> 
                                <button v-if="!readOnly && !doc.deleting && !doc.uploading" type="button" class="btn btn-danger btn-sm" @click="deleteFile(doc)">
                                    <i class="fa fa-archive" aria-hidden="true"></i></button> 
                                <button v-else-if="!readOnly && doc.deleting" type="button" class="btn btn-danger btn-sm">
                                    <i class="fas fa-sync fa-spin"></i></button> 
                                <button v-else-if="!readOnly" type="button" class="btn btn-danger btn-sm" disabled>
                                    <i class="fa fa-archive" aria-hidden="true"></i></button> 
                                    
                            </div>  
                                            
                        </div>
                      

                        <div v-show="showDocs">                           
                            <div  v-for="doc in docsTail" :key="doc.index" class="row d-flex pl-4 pt-2 pr-4 pb-2" >                           
                                <div class="pl-2">
                                    {{doc.document.orig_name}}
                                </div>
                                <div v-if="doc.waiting" class="pl-2">
                                    Waiting for Upload
                                </div>
                                <div v-else-if="doc.uploading" class="pl-2">
                                    <i class="fas fa-sync fa-spin"></i> Uploading
                                </div>
                                <div v-else-if="doc.error" class="pl-2 text-danger">
                                    The upload failed
                                </div>
                                <div v-else class="pl-2 text-success">
                                    Uploaded
                                </div>
                                <div class="pl-2">
                                    <button v-if="allowCopy && doc.cdnLink !== null && !doc.waiting && !doc.uploading && !doc.error && !doc.deleting && (getExtension(doc.document.orig_name) == '.png' || getExtension(doc.document.orig_name) == '.gif' || getExtension(doc.document.orig_name) == '.jpg' || getExtension(doc.document.orig_name) == '.jpeg')" type="button" class="btn btn-primary btn-sm" @click="copyPublic(doc)">
                                        <i class="fa fa-copy" aria-hidden="true"></i></button> 
                                    <a v-if="!doc.waiting && !doc.uploading && !doc.error && !doc.deleting" type="button" class="btn btn-primary btn-sm" :href="doc.route" target="_blank">
                                        <i class="fa fa-download" aria-hidden="true"></i></a> 
                                    <a v-else type="button" class="btn btn-primary btn-sm" disabled target="_blank">
                                        <i class="fa fa-download" aria-hidden="true"></i></a> 
                                    <button v-if="!readOnly && !doc.deleting && !doc.uploading" type="button" class="btn btn-danger btn-sm" @click="deleteFile(doc)">
                                        <i class="fa fa-archive" aria-hidden="true"></i></button> 
                                    <button v-else-if="!readOnly && doc.deleting" type="button" class="btn btn-danger btn-sm">
                                        <i class="fas fa-sync fa-spin"></i></button> 
                                    <button v-else-if="!readOnly" type="button" class="btn btn-danger btn-sm" disabled>
                                        <i class="fa fa-archive" aria-hidden="true"></i></button> 
                                </div>                   
                            </div>
                        </div>                       
                    </div>
                </div>
            </div>

            <div v-if="!readOnly && !maxUploadReached" class="col-md-5">
                <div class="card h-100">
                    <div class="card-block">
                        <div class="card-header bg-light pb-0">		
                            <label class="text-20 text-info">Upload New</label>
                        </div>
                        <div class="col-md-12 pt-2"> 
                            <label for="">Select File to Upload</label>
                            <div class="input-group">
                                <div class="custom-file">
                                    <input type="file" :accept="allowedMimeTypes" class="custom-file-input form-control" id="exampleInputFile" :multiple="multi" @change="filesChange($event.target.files);">
                                    <label class="custom-file-label" for="exampleInputFile" style="width:100%;">
                                        Please select file
                                    </label>
                                </div>
                            </div>
                            <div clas="row">
                                <i class="small"><b class="text-muted">Allowed Extensions:</b> {{allowedExtensionsList}}<br>
                                <b class="text-muted"> Max file size:</b> {{maxSizeNice}}</i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div><!-- END row -->

        <div v-else class="row">
            <div class="col-12 form-group files">
                <input v-if="required" type="file" :accept="allowedMimeTypes" class="form-control" id="exampleInputFile" multiple="false" @change="filesChange($event.target.files);" required>
                <input v-else type="file" :accept="allowedMimeTypes" class="form-control" id="exampleInputFile" multiple="false" @change="filesChange($event.target.files);">
                <div class="invalid-feedback">Please Drop and Drag a file or Browse file to upload</div>
            </div>
            <div class="col-12">
                <div v-for="doc in docsHead" :key="doc.index" class="row d-flex pl-4 pt-2 pr-4 pb-2">                           
                    <div class="pl-2">
                        {{doc.document.orig_name}}
                    </div>
                    <div v-if="doc.waiting" class="pl-2">
                        Waiting for Upload
                    </div>
                    <div v-else-if="doc.uploading" class="pl-2">
                        <i class="fas fa-sync fa-spin"></i> Uploading
                    </div>
                    <div v-else-if="doc.error" class="pl-2 text-danger">
                        The upload failed
                    </div>
                    <div v-else class="pl-2 text-success">
                        Uploaded
                    </div>
                    <div class="pl-2 ml-auto">
                        <a v-if="!doc.waiting && !doc.uploading && !doc.error && !doc.deleting" type="button" class="btn btn-primary btn-sm" :href="doc.route" target="_blank">
                            <i class="fa fa-download" aria-hidden="true"></i></a> 
                        <a v-else type="button" class="btn btn-primary btn-sm" disabled target="_blank">
                            <i class="fa fa-download" aria-hidden="true"></i></a> 
                        <button v-if="!readOnly && !doc.deleting && !doc.uploading" type="button" class="btn btn-danger btn-sm" @click="deleteFile(doc)">
                            <i class="fa fa-archive" aria-hidden="true"></i></button> 
                        <button v-else-if="!readOnly && doc.deleting" type="button" class="btn btn-danger btn-sm">
                            <i class="fas fa-sync fa-spin"></i></button> 
                        <button v-else-if="!readOnly" type="button" class="btn btn-danger btn-sm" disabled>
                            <i class="fa fa-archive" aria-hidden="true"></i></button> 
                    </div> 
                                       
                </div>
                <div v-show="showDocs">                           
                    <div  v-for="doc in docsTail" :key="doc.index" class="row d-flex pl-4 pt-2 pr-4 pb-2" >                           
                        <div class="pl-2">
                            {{doc.document.orig_name}}
                        </div>
                        <div v-if="doc.waiting" class="pl-2">
                            Waiting for Upload
                        </div>
                        <div v-else-if="doc.uploading" class="pl-2">
                            <i class="fas fa-sync fa-spin"></i> Uploading
                        </div>
                        <div v-else-if="doc.error" class="pl-2 text-danger">
                            The upload failed
                        </div>
                        <div v-else class="pl-2 text-success">
                            Uploaded
                        </div>
                        <div class="pl-2">
                            <a v-if="!doc.waiting && !doc.uploading && !doc.error && !doc.deleting" type="button" class="btn btn-primary btn-sm" :href="doc.route" target="_blank">
                                <i class="fa fa-download" aria-hidden="true"></i></a> 
                            <a v-else type="button" class="btn btn-primary btn-sm" disabled target="_blank">
                                <i class="fa fa-download" aria-hidden="true"></i></a> 
                            <button v-if="!readOnly && !doc.deleting && !doc.uploading" type="button" class="btn btn-danger btn-sm" @click="deleteFile(doc)">
                                <i class="fa fa-archive" aria-hidden="true"></i></button> 
                            <button v-else-if="!readOnly && doc.deleting" type="button" class="btn btn-danger btn-sm">
                                <i class="fas fa-sync fa-spin"></i></button> 
                            <button v-else-if="!readOnly" type="button" class="btn btn-danger btn-sm" disabled>
                                <i class="fa fa-archive" aria-hidden="true"></i></button> 
                              
                        </div>  
                                       
                    </div>
                </div>
            </div>
        </div>
        <div class="row p-3">
            <span v-for="doc in documentList" :key="doc.index">
                <span v-if="isImage(doc)">
                    <img :src="doc.route" alt="" class="img-thumbnail" width="320" >
                </span>
            </span>
        </div>
    </div>
</template>

<script>
    import mimeTypes from "./MimeTypes";
    export default{
        props: {
            //the name of the input
            name: {
                type: String,
                default: 'files'
            },
            //whether or not it is read only
            readOnly: {
                type: Boolean,
                default: false
            },
            //whether or not allow multiple file uploads
            multi: {
                type: Boolean,
                default: false
            },
            //whether or not the document upload is required
            required: {
                type: Boolean,
                default: false
            },
            //the type of file
            type: {
                type: Object
            },
            //the route to create a new skill
            uploadRoute: {
                type: String,
                default: ''
            },
            //the array of cv objects to display
            value: {
                type: Array
            },
            maxFiles: {
                type: Number,
                default: 5000
            },
            //whether or not to allow links to be copied
            allowCopy: {
                type: Boolean,
                default: false
            }
        },
        mounted(){
            
        },
        data() {
            return {
                text: '',
                documentList: [...this.value],
                uploading: false,
                allowedExtensions: this.type !== undefined && this.type.allowedExtensions !== undefined ? this.type.allowedExtensions : ['.pdf','.doc','.docx','.txt','.rtf','.png','.jpg','.jpeg','.gif','.xls','.xlsx','.ppt','.pptx','.mp3','.wmv','.mp4','.m4v','.avi','.webm'],
                maxSize: this.type !== undefined && this.type.maxSize !== undefined ? this.type.maxSize : 10485760, 
                maxSizeNice:  this.type !== undefined && this.type.maxSizeNice !== undefined ? this.type.maxSizeNice : '10Mb',
                typeActual: this.type,
                uploadRouteActual: this.uploadRoute,
                showDocs: false,
                maxUploadReached: false
            }
        },
        computed: {
            allowedMimeTypes: function(){
                var accept = '';
                var comma = '';
                for(var i=0; i<this.allowedExtensions.length; i++){
                    var mime = mimeTypes.getMimeType(this.allowedExtensions[i]).mimeType;
                    if(mime.length > 0){
                        accept = accept + comma + mime;
                        comma = ',';
                    }
                }
                return accept;
            },
            allowedExtensionsList: function(){
                var accept = '';
                var comma = '';
                for(var i=0; i<this.allowedExtensions.length; i++){
                    accept = accept + comma + this.allowedExtensions[i];
                    comma = ', ';
                }
                return accept;
            },
            uploadedDocuments: function(){
                return this.getUploadedDocuments();
            },
             docsHead() {
                return this.documentList ? this.documentList.slice(0, 3) : [];
            },
            docsTail() {
                return this.documentList ? this.documentList.slice(3) : [];
            }
        },
        methods: {
            getUploadedDocuments: function(){
                var arr = [];
                for(var i=0; i<this.documentList.length; i++){
                    if(!this.documentList[i].waiting && !this.documentList[i].uploading && !this.documentList[i].error && this.documentList[i].document.id > 0){
                        arr.push(this.documentList[i].document.id);
                    }
                }
                return arr;
            },
            filesChange: function (fileLister){
                if(!this.multi){
                    for(var i=0; i<this.documentList.length; i++){
                        this.deleteFile(this.documentList[i]);
                    }
                    this.documentList = [];
                    this.uploading = false;
                }
                
                for(var i=0; i<fileLister.length; i++){
                    var check = this.checkValidFile(fileLister[i]);
                    if(check.valid){
                        var doc = {
                            file: fileLister[i],
                            document: {
                                id: 0, 
                                name: fileLister[i].name,
                                orig_name: fileLister[i].name,
                                type: this.typeActual.id,
                                
                            },
                            waiting: true,
                            uploading: false,
                            error: false,
                            deleting: false,
                            route: '',
                            deleteRoute: ''
                        };
                        this.documentList.unshift(doc);
                    } else {
                        alert(check.message);
                    }
                }
                this.checkQueueFile();
            },
            checkValidFile: function (file)
            {
                if(file === null || file === undefined || file.name.length == 0)
                {
                    return {
                        valid: false,
                        message: 'Invalid File'
                    };
                }
                else
                {
                    var split = file.name.split(".");
                    var extension = "." + split[split.length-1].toLowerCase();
                    if(this.allowedExtensions.length == 0 || this.allowedExtensions.indexOf(extension) >= 0 || this.allowedExtensions == 'All')
                    {
                        var size = file.size;
                        if(size == -1 || (size <= this.maxSize && size > 0))
                        {
                            return {
                                valid: true,
                                message: ''
                            };
                        }
                        else if(size <= 0)
                        {
                            return {
                                valid: false,
                                message: 'The file size is 0 bytes. The file must contain some data.'
                            };
                        }
                        else
                        {
                            return {
                                valid: false,
                                message: 'The file size is too big. It must be no more than ' + this.maxSizeNice + '.'
                            };
                        }
                    }
                    else
                    {
                        return {
                            valid: false,
                            message: 'The file format ' + extension + ' is not supported. It must be one of the following: ' + this.allowedExtensions
                        };
                    }
                }
            },
            /**
             * checks if there is a document to upload and that we arn't already uploading. If so, uploads the file
             */
            checkQueueFile: function() {
                if(!this.uploading){
                    for(var i=0; i<this.documentList.length; i++){
                        if(this.documentList[i].waiting){
                            this.uploadFile(this.documentList[i]);
                            i = this.documentList.length;
                        }
                    }
                }
            },
            /**
             * uploads the document
             */
            uploadFile: function (document) {
                console.log('uploading: ' + document.document.orig_name + ' to: ' + this.uploadRouteActual + ' type: ' + document.document.type);
                this.uploading = true;
                document.uploading = true;
                document.waiting = false;
                var error_occured = false;
                var self = this;
                const formData = new FormData();
                formData.append('file', document.file, document.file.name);
                formData.append('type', document.document.type);
                formData.append('allowCopy', this.allowCopy ? 1 : 0);
                this.$http.post(
                    this.uploadRouteActual, 
                    formData
                ).then(function (response) {
                    if(!error_occured){
                        if(response.data.error !== undefined){
                            error_occured = true;
                            document.error = true;
                            console.log('An error occurred uploading the document');
                            console.log(response.data.error);
                        } else {
                            console.log(response.data);
                            document.document = response.data.document;
                            document.route = response.data.route;
                            document.deleteRoute = response.data.deleteRoute;
                            if(self.allowCopy && response.data.cdnLink !== undefined){
                                document.cdnLink = response.data.cdnLink;
                            }
                        }
                    } else {
                        document.error = true;
                    }
                }).catch((error) => {
                    error_occured = true;
                    
                    console.log('An error occurred uploading the document');
                    if(error.response !== undefined){
                        console.log('File: ' + error.response.data.file);
                        console.log('Line: ' + error.response.data.line);
                        console.log('Message: ' + error.response.data.message);
                        console.log('Exception: ' + error.response.data.exception);
                        console.log(error.response.data.trace);
                    } else {
                        console.log(error);
                    }
                }).then(function () {
                    if(!error_occured){
                        
                    } else {
                        document.error = true;
                    }
                    document.uploading = false;
                    self.uploading = false;
                    self.updateDocs(self.documentList);
                    self.checkQueueFile();
                });
            },
            /**
             * deletes the document
             * @param Object document the document to delete
             */
            deleteFile: function (document) {
                if(confirm('Are you sure you want to delete ' + document.document.orig_name + '?')){
                    console.log('deleting: ' + document.document.orig_name);
                    if(!document.waiting && !document.uploading && !document.error && !document.deleting){
                        var error_occured = false;
                        var self = this;
                        document.deleting = true;
                        this.$http.delete(
                            document.deleteRoute
                        ).then(function (response) {
                            if(!error_occured){
                                if(response.data.error !== undefined){
                                    error_occured = true;
                                    console.log('An error occurred deleting the document');
                                    console.log(response.data.error);
                                } else {
                                    console.log(response.data);
                                    var arr = [];
                                    for(var i=0; i<self.documentList.length; i++){
                                        if(self.documentList[i].document.id == document.document.id){
                                        } else {
                                            arr.push(self.documentList[i]);
                                        }
                                    }
                                    self.documentList = arr;
                                    self.updateDocs(self.documentList);
                                }
                            } else {
                                document.error = true;
                            }
                        }).catch((error) => {
                            error_occured = true;
                            
                            console.log('An error occurred deleting the document');
                            if(error.response !== undefined){
                                console.log('File: ' + error.response.data.file);
                                console.log('Line: ' + error.response.data.line);
                                console.log('Message: ' + error.response.data.message);
                                console.log('Exception: ' + error.response.data.exception);
                                console.log(error.response.data.trace);
                            } else {
                                console.log(error);
                            }
                        }).then(function () {
                            document.deleting = false;
                        });
                    } else {
                        var arr = [];
                        for(var i=0; i<this.documentList.length; i++){
                            if((this.documentList[i].waiting || this.documentList[i].error) && document.document.id == 0 && document.document.fileName == this.documentList[i].document.fileName){
                            } else {
                                arr.push(this.documentList[i]);
                            }
                        }
                        this.documentList = arr;
                        this.updateDocs(this.documentList);
                    }
                }
            },
            /**
             * deletes the document
             * @param Object document the document to delete
             */
            updateDocs: function (docList) {
                var arr = [];
                for(var i=0; i<docList.length; i++){
                    if(!docList[i].waiting && !docList[i].uploading && !docList[i].error){
                        arr.push(docList[i]);
                    }
                }
                this.$emit('input', arr);
                this.$emit('docsChanged', arr);
            }
            ,
            /**
             * this method sets the type to new values
             * @param Object type the document type array
             */
            setType: function (type) {
                console.log(type);
                this.documentList = [...type.documents];
                this.allowedExtensions = type.type.allowedExtensions;
                this.maxSize = type.type.maxSize;
                this.maxSizeNice = type.type.maxSizeNice;
                this.typeActual = type.type;
                this.uploadRouteActual = type.uploadRoute;
            },
            /** show the first 3 documents, then on button click show the rest*/
            show_all_docs: function(){
                this.showDocs = true
            },  
            getExtension: function(filename){
                var split = filename.split(".");
                var extension = "." + split[split.length-1].toLowerCase();
                return extension
            },
            copyPublic: function(doc){
                if(doc.cdnLink !==undefined && doc.cdnLink !== null){
                    navigator.clipboard.writeText(doc.cdnLink);
                } else {
                    navigator.clipboard.writeText(doc.route);
                }
                this.$refs.flashmessage.flash('Copied image link to clipboard', 'success');
            },
            isImage: function(doc){
                var extension = this.getExtension(doc.document.orig_name);
                return ['.jpg', '.jpeg', '.png', '.gif'].includes(extension);
            }
        },
        watch: {
            documentList: {
                deep: true,
                immediate: true,
                handler() {
                    if (this.maxFiles && this.documentList.length >= parseInt(this.maxFiles)) {
                        this.maxUploadReached = true;
                    } else {
                        this.maxUploadReached = false;
                    }
                }
            }
        }
    }
</script>